import { merge, $, media, presets } from "glamor";
import { theme } from "styles/theme";

export const exportMerchantStyles = merge(
    $(".notification", {
        margin: "10px 0",
        display: "inline-flex",
    })
);

const exportStyles = merge(
    $(" .formUpcContainer", {
        marginBottom: "40px",
    }),
    $(" .formGroupContainer > div", {
        width: "100%",
        display: "flex",
        flexDirection: "column",
    }),
    $(" .labelValue", {
        fontSize: "14px",
        color: theme.palette.darkerGrey,
    }),
    $(" .MuiCheckbox-root.Mui-disabled + span", {
        color: theme.palette.disabledColor,
        cursor: "not-allowed",
    }),
    $(" .bottomRow", {
        marginTop: "30px",
    }),
    $(" .checkbox", {
        marginLeft: "9px",
        marginTop: "-4px",
    }),
    $(" .buttonContainer", {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "16px",
    }),
    $(".loadingExport", {
        display: "flex",
        flexDirection: "column",
        height: "108px",
        justifyContent: "space-between",
    }),
    $(".closeButton ", {
        marginBottom: "20px",
        marginLeft: "10px",
    }),
    $(".loadingExport > div", {
        margin: "0 auto",
    }),
    $(".downloadExport", {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }),
    $(" .MuiCheckbox-colorSecondary.Mui-checked", {
        color: theme.palette.accent1Color,
    }),
    $(" .MuiCheckbox-root .MuiSvgIcon-root", {
        fontSize: "23px",
    }),
    $(" .MuiFormControlLabel-label", {
        fontSize: "14px",
        lineHeight: "24px",
        fontFamily: "'Lato', sans-serif",
        color: theme.palette.textColor,
    }),
    $(" .validationError", {
        color: theme.palette.warning,
        marginTop: "15px",
    }),
    media(
        presets.phablet,
        merge(
            $(" .formGroupContainer", {
                display: "flex",
            })
        )
    )
);

export const styles = {
    content: {
        padding: "20px 0",
    },
    label: {
        marginTop: "20px",
        marginBottom: "10px",
        fontFamily: "'Lato', sans-serif",
        color: theme.palette.textColor,
        fontWeight: "bold",
        fontSize: "12px",
    },
    buttons: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "50px",
    },
    button: {
        cancel: {
            marginRight: "4px",
        },
        export: {
            marginLeft: "4px",
        },
    },
    permissionSelector: {
        width: "150px",
    },
    selectedMenuItem: {
        fill: theme.palette.primary1Color,
    },
    subMenuItem: {
        minWidth: 150,
    },
};
export default exportStyles;
